import { createContext, useState } from "react";

export const BookingFormContext = createContext<BookingFormContextValue | null>(
  null
);

type BookingFormContextValue = {
  selectedLocationId: string;
  selectedBarberId: string;
  selectedServiceIds: string[];
  selectedDate: string;
  selectedTime: string;
  name: string;
  phone: string;
  setSelectedLocationId: (locationId: string) => void;
  setSelectedBarberId: (barberId: string) => void;
  setSelectedServiceIds: (serviceId: string[]) => void;
  setSelectedDate: (date: string) => void;
  setSelectedTime: (time: string) => void;
  setName: (name: string) => void;
  setPhone: (phone: string) => void;
};

export function BookingFormContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  let [selectedLocationId, setSelectedLocationId] = useState("");
  let [selectedBarberId, setSelectedBarberId] = useState("");
  let [selectedServiceIds, setSelectedServiceIds] = useState<string[]>([]);
  let [selectedDate, setSelectedDate] = useState("");
  let [selectedTime, setSelectedTime] = useState("");
  let [name, setName] = useState("");
  let [phone, setPhone] = useState("");

  return (
    <BookingFormContext.Provider
      value={{
        selectedLocationId,
        selectedBarberId,
        selectedServiceIds,
        selectedDate,
        selectedTime,
        name,
        phone,
        setSelectedLocationId,
        setSelectedBarberId,
        setSelectedServiceIds,
        setSelectedDate,
        setSelectedTime,
        setName,
        setPhone,
      }}
    >
      {children}
    </BookingFormContext.Provider>
  );
}
